import { lowerCase } from 'es-toolkit';
import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Button, Paper, Stack, SxProps, Theme, Tooltip, Typography } from '@mui/material';

import { SerializedEntitySnapTarget } from '../../../../../library/layout-snapping/EntitySnapTarget';
import { TOGGLE_LOCK_TO_BASE_HOTKEY } from '../../../../../store/actions/globalHotkeyActions';
import { layoutSlice } from '../../../../../store/slices/layoutSlice';
import { useAppDispatch } from '../../../../hooks';

export function LockedTrussEnvelopeTargetControl(
  props: { sx?: SxProps<Theme> } & (
    { condensed: true } | { condensed?: false; lockedTarget: SerializedEntitySnapTarget }
  ),
) {
  const dispatch = useAppDispatch();

  return (
    <Paper variant="outlined" sx={props.sx}>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <LockOutlinedIcon />
        <Typography variant="body2" sx={{ textWrap: 'wrap' }}>
          {props.condensed
            ? 'Base locked.'
            : `Snapping locked to manually chosen ${lowerCase(props.lockedTarget.type)}.`}
        </Typography>

        <Tooltip disableInteractive title={`(Ctrl + ${TOGGLE_LOCK_TO_BASE_HOTKEY.toUpperCase()})`}>
          <span>
            <Button size="small" onClick={() => dispatch(layoutSlice.actions.trussEnvelopeSnappingTargetLocked(null))}>
              Clear
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </Paper>
  );
}
